import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

import { VOLUME_CONVERSION } from './constants';
import Button from '../../ui/Button';
import ComponentContainer from '../../ui/ComponentContainer';

import useContextVolume from './hooks/useContextVolume';

import './ConversionCalculator.css';

function VolumeConversion() {
    const { t } = useTranslation();
    const {
        handleNotes,
        handleUnits,
        handleUnitsEnter,
        handleSavingNotes,
        handleDeletingNotes,
        state,
        dispatch,
    } = useContextVolume();

    useEffect(() => handleNotes('volumeNotes'), []);

    return (
        <ComponentContainer variant="calculatorContainer">
            <h2>{t('calculator.volume_conversion.hdl')}</h2>
            <div className="calculator-box">
                <input
                    type="number"
                    value={state.input}
                    className="calculator-input"
                    onChange={(e) =>
                        dispatch({
                            type: 'SET_INPUT',
                            payload: Number(e.target.value),
                        })
                    }
                    onKeyDown={(e) => {
                        if (e.key === 'Enter')
                            handleUnitsEnter(4.93, 'ml', 'teaspoon');
                    }}
                />
                {VOLUME_CONVERSION.map(({ value, multiplier, unit, id }) => (
                    <Button
                        key={id}
                        variant="nav"
                        onClick={() => handleUnits(multiplier, unit, value)}
                        active={id === 1 && state.active}
                    >
                        {t(`calculator.volume_conversion.${value}`)}{' '}
                        <FontAwesomeIcon icon={faArrowRight} />{' '}
                        {t(`calculator.volume_conversion.${unit}`)}
                    </Button>
                ))}
            </div>

            <div className="calculator-box-result">
                <h3 className="calculator-result">
                    {' '}
                    {t('calculator.result')} {state.result}
                </h3>
                <Button
                    variant="back"
                    onClick={() => handleSavingNotes('volumeNotes')}
                    disabled={!state.input && !state.unit && !state.result}
                >
                    {t('calculator.save')}
                </Button>
            </div>
            <div className={state.open ? 'calculator-notes-box' : 'no-visible'}>
                <h2> {t('calculator.notes')}</h2>
                {state.notes.length > 0 ? (
                    <ul>
                        {state.notes.map((note, index) => (
                            <li key={index}>{note}</li>
                        ))}
                    </ul>
                ) : (
                    <p> {t('calculator.no_notes')}</p>
                )}
                <Button
                    variant="delete"
                    onClick={() => handleDeletingNotes('volumeNotes')}
                >
                    {t('calculator.delete')}
                </Button>
            </div>
        </ComponentContainer>
    );
}

export default VolumeConversion;
